import { Text } from "@chakra-ui/layout";

export const PageSubheading = ({ children }) => {
  return <Text fontSize={{base: "md", lg: "lg"}} lineHeight="1.8">{children}</Text>;
};
